import { Spinner } from "flowbite-react";

export function Loader({ size }) {
    return <Spinner aria-label="Loading spinner" size={size} />;
}